<template>
  <div class="match-schedule">
    <p class="page-tit" :style="{ color: headType === '2' ? '#B9A2C9' : '' }">
      {{ $t("basketball.nav0") }}
    </p>
    <div class="match-box">
      <el-tabs
        class="istab-bg"
        v-if="headType === '1'"
        v-model="activeNameBoys"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in tabnames"
          :key="index"
          :label="$t('schedule.' + item.tabname)"
          :name="String(index)"
          @tab-click="tabchange(item.id)"
        >
          <div
            class="match-tit"
            :style="{ background: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("schedule." + item.tabname) }} - {{ $t("schedule.result") }}
          </div>
          <MatchCom
            :currentIndex="currentIndex"
            v-loading="metchLoading"
            @monthtab="monthtab"
            @teamId="teamId"
            :monthList="monthLists"
            :roundList="roundsList"
            :tabid="tabid"
            ref="current"
            :girltabid="girltabid"
            :team="team"
            :total="total"
            :handleCurrentChange="handleCurrentChange"
          />
        </el-tab-pane>
      </el-tabs>
      <el-tabs
        class="istab-bg"
        :class="headType === '2' ? 'girltab' : ''"
        v-else
        v-model="activeNameGirls"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in tabnames"
          :key="index"
          :label="$t('schedule.' + item.tabname)"
          :name="String(index)"
          @tab-click="tabchange(item.id)"
        >
          <div
            class="match-tit"
            :style="{ background: headType === '2' ? '#B9A2C9' : '' }"
          >
            {{ $t("schedule." + item.tabname) }} - {{ $t("schedule.result") }}
          </div>
          <MatchCom
            :currentIndex="currentIndex"
            v-loading="metchLoading"
            @monthtab="monthtab"
            @teamId="teamId"
            :monthList="monthLists"
            :roundList="roundsList"
            :tabid="tabid"
            ref="current"
            :girltabid="girltabid"
            :team="team"
            :total="total"
            :handleCurrentChange="handleCurrentChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="coming">
      <h2>{{$t('home.nodata')}}</h2>
    </div> -->
  </div>
</template>

<script>
import { BasketballApi } from "../api/basketball";
import { mapState } from "vuex";
import MatchCom from "./components/matchschedule/MatchCom.vue";

export default {
  components: {
    MatchCom
  },
  data() {
    return {
      currentIndex: 0,
      metchLoading: false,
      // monthList: '',
      schedule_id: "",
      competitions: "",
      results: [],
      roundsList: [],
      latestList: [],
      page: 1,
      total: 0,
      monthList: [
        { mon: this.$t("months.all"), num: "all" },
        { mon: this.$t("months.november"), num: "2024-11" },
        { mon: this.$t("months.december"), num: "2024-12" },
        { mon: this.$t("months.january"), num: "2025-01" },
        { mon: this.$t("months.february"), num: "2025-02" },
        { mon: this.$t("months.march"), num: "2025-03" },
        { mon: this.$t("months.april"), num: "2025-04" },
        { mon: this.$t("months.may"), num: "2025-05" },
        { mon: this.$t("months.june"), num: "2025-06" },
        { mon: this.$t("months.july"), num: "2025-07" },
        { mon: this.$t("months.august"), num: "2025-08" }
      ],
      monthList_girl: [
        { mon: this.$t("months.all"), num: "all" },
        { mon: this.$t("months.november"), num: "2024-11" },
        { mon: this.$t("months.december"), num: "2024-12" },
        { mon: this.$t("months.january"), num: "2025-01" },
        { mon: this.$t("months.february"), num: "2025-02" },
        { mon: this.$t("months.march"), num: "2025-03" },
        { mon: this.$t("months.april"), num: "2025-04" },
        { mon: this.$t("months.may"), num: "2025-05" },
        { mon: this.$t("months.june"), num: "2025-06" },
        { mon: this.$t("months.july"), num: "2025-07" },
        { mon: this.$t("months.august"), num: "2025-08" }
      ],
      activeNameBoys: "",
      activeNameGirls: "0",
      montabId: "",
      showcom: "Schedule1",
      tablist: [
        { id: "", tabname: "All" },
        { id: 1, tabname: "hot" },
        { id: 2, tabname: "group" },
        { id: 3, tabname: "gold" },
        { id: 4, tabname: "silver" },
        { id: 5, tabname: "silver_plate" },
        { id: 7, tabname: "grand_finals" }
      ],
      girltablist: [
        { id: "", tabname: "All" },
        { id: 13, tabname: "hot" },
        { id: 10, tabname: "group_girl" },
        { id: 17, tabname: "gold" },
        { id: 18, tabname: "silver" },
      ],
      tabid: "",
      girltabid: "",
      tab: "",
      search_id: "92",
      team: [],
      team_id: ""
    };
  },
  watch: {
    headType() {
      this.getScheduleRoundsList();
      this.getMonth()
      this.monthtab();
    }
  },
  computed: {
    ...mapState(["headType"]),
    // eslint-disable-next-line vue/return-in-computed-property
    tabnames() {
      if (this.headType === "1") {
        return this.tablist;
      } else if (this.headType === "2") {
        return this.girltablist;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    monthLists() {
      if (this.headType === "1") {
        return this.monthList;
      } else if (this.headType === "2") {
        return this.monthList_girl;
      }
    }
  },
  created() {
    this.getScheduleRoundsList();
    this.getTeams();
  },
  methods: {
    teamId(val) {
      this.team_id = val;
      this.getScheduleRoundsList();
    },
    monthtab(val, index) {
      this.montabId = val;
      this.currentIndex = index;
      this.getScheduleRoundsList();
    },
    getCurrentYear(){
      return new Date().getFullYear();
    },
    //获取队伍列表
    getTeams() {
      let year = "2024" //change the year baase on current team year
      BasketballApi.getTeams({
        year: year,
        type: this.headType === "1" ? "m" : "w"
      }).then(res => {
        let arr = [
          {
            label: this.$t("home.alldata"),
            value: " "
          }
        ];
        res.forEach(item => {
          let obj = new Object();
          obj.value = item.id;
          obj.label = item.name;
          arr.push(obj);
        });
        this.team = arr;
      });
    },
    //获取赛程列表
    getScheduleRoundsList() {
      this.metchLoading = true;
      this.roundsList = [];
      let year = this.getCurrentYear();
      BasketballApi.getScheduleRoundsList(
        this.page,
        this.headType == "2" ? this.girltabid : this.tabid,
        this.team_id,
        this.montabId == "all" ? "" : this.montabId,
        this.headType === "1" ? "m" : "w",
        "c",
        year
      ).then(res => {
        this.roundsList = res.competitions;
        this.total = res.total_count;
        this.metchLoading = false;
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getScheduleRoundsList();
    },
    statspage() {
      this.$router.push({ path: "/stats", query: { type: this.headType } });
    },
    handleClick() {
      if (this.headType == "1") {
        this.tablist.map((el, index) => {
          if (this.activeNameBoys == index) {
            this.tabid = el.id;
            this.page = 1;
          }
        });
      } else {
        this.girltablist.map((el, index) => {
          if (this.activeNameGirls == index) {
            this.girltabid = el.id;
            this.page = 1;
          }
        });
      }
      this.montabId = "";
      this.getScheduleRoundsList();
      this.currentIndex = 0;
    },
    tabchange(id) {
      this.id = id;
    }
  }
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.match-schedule {
  .match-box {
    box-shadow: 2px 2px 15px #8888886c;
    border-radius: 15px;
    overflow: hidden;

    .standing-bg {
      box-shadow: 2px 2px 15px #8888886c;
      background: #fff;
      display: flex;
      // border: 2px solid #c2cfe573;
      // border-bottom: none;
      border-radius: 20px 20px 0 0;

      // justify-content: space-around;
      .tab {
        padding: 20px 30px;
        cursor: pointer;
        font-size: 17px;
        color: #318bc8;
        border-radius: 18px 18px 0 0;
      }

      .active {
        // background-color: orange;
        color: #fff;
        background: #318bc8;
      }
    }

    .match-tit {
      background: #318bc8;
      line-height: 60px;
      text-align: left;
      padding-left: 35px;
      color: #fff;
      font-size: 20px;
      // border: 2px solid #fff;
      border-top: none;
    }

    .match-tab {
      .tab ul {
        overflow: hidden;
        margin-bottom: 2px;
        display: flex;
        margin-top: 15px;
        border-bottom: 2px solid rgb(238, 236, 236);
        justify-content: space-around;
      }

      .tab ul li {
        list-style: none;
        text-align: center;
        cursor: pointer;
        font-size: 17px;
        color: rgb(222, 228, 228);
        padding: 0 10px;
      }

      .tab ul li.active {
        // background-color: orange;
        color: #2d3b51;
        border-bottom: 3px solid #2d3b51;
      }

      .tab {
        .show-box {
          width: 100%;
          height: 100%;
          text-align: center;
          display: none;

          :hover {
            background: #eff5fa;
          }

          .tab-content {
            display: flex;
            justify-content: space-around;
            border-bottom: 2px solid #c5cfe348;
            // margin-top: 30px;

            .play-box {
              width: 20%;
              height: 100px;
              margin: 10px;
              padding-top: 10px;
            }

            .play-time,
            .play-tit,
            .play-stats {
              line-height: 25px;
              width: 17%;
              color: #2d3b51;
            }

            .play-team1,
            .play-team2 {
              width: 30%;
              display: flex;
              justify-content: center;
              padding-top: 30px;

              .play-txt1 {
                text-align: right;

                .sp1 {
                  color: #5aa2d3;
                }

                .sp2 {
                  font-size: 18px;
                  font-weight: 600;
                  color: #2d3b51;
                }
              }

              .play-txt2 {
                margin: 0 20px;
                margin-top: -10px;

                img {
                  border-radius: 10px;
                }
              }

              .play-txt3 {
                font-size: 30px;
                font-weight: 600;
                color: #c2cfe5;
              }
            }
          }

          .play-stats {
            p {
              margin-top: 30px;
              cursor: pointer;
            }

            i {
              color: #5aa2d3;
            }

            :hover {
              color: #5aa2d3;
            }
          }
        }
      }

      .tab .show-box.current {
        display: block;
      }
    }
  }
}
</style>
